import { trimTime, numberToTime } from 'src/app/shared/functions/date-time-functions';

export const barChartTimeOptions: any = {
  legend: {
    display: true,
  },
  scaleShowVerticalLines: false,
  elements: {
    line: {
      fill: false,
      tension: .2, // disables bezier curves
      borderDash: [],
      borderCapStyle: 'butt',
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter'
    },
    point: {
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      hoverRadius: 5,
      hoverBorderWidth: 2,
      radius: 5,
      hitRadius: 10
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        display: false
      },
      stacked: false
    }],
    yAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'Tempo em Minutos'
      },
      gridLines: {
        display: true
      },
      stacked: false,
      ticks: {
        beginAtZero: true,
        // Include a dollar sign in the ticks
        callback: (value, index, values) => {
          return numberToTime(value);
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const allData = data.datasets[tooltipItem.datasetIndex].data;
        const tooltipLabel = data.labels[tooltipItem.index];
        const dataValue = allData[tooltipItem.index];
        const dataLabel = data.datasets[tooltipItem.datasetIndex].label;

        return `${ dataLabel }: ${ numberToTime(dataValue) }`;
      }
    }
  },
  plugins: {
    datalabels: {
      display: true,
      backgroundColor: 'white',
      // backgroundColor: function(context) {
      //   return context.dataset.backgroundColor;
      // },
      borderRadius: 5,
      color: '#333',
      font: {
        weight: 'bold'
      },
      align: 'end',
      anchor: 'start',
      padding: 3,
      opacity: .7,
      formatter: function (value, context) {
        return numberToTime(value);
      }
    }
  }
};
